// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-feuille {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.import-btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #4a90d9;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.import-btn:hover {
  background-color: #357abd;
}

.import-btn input[type="file"] {
  display: none;
}


.import-message {
  font-size: 14px;
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/components/import_feuille/import_feuille.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".import-feuille {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.import-btn {\n  display: inline-block;\n  padding: 10px 20px;\n  background-color: #4a90d9;\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.import-btn:hover {\n  background-color: #357abd;\n}\n\n.import-btn input[type=\"file\"] {\n  display: none;\n}\n\n\n.import-message {\n  font-size: 14px;\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
